import { render, staticRenderFns } from "./PageWrapperActionButton.vue?vue&type=template&id=42812cea&scoped=true"
import script from "./PageWrapperActionButton.vue?vue&type=script&lang=ts"
export * from "./PageWrapperActionButton.vue?vue&type=script&lang=ts"
import style0 from "./PageWrapperActionButton.vue?vue&type=style&index=0&id=42812cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42812cea",
  null
  
)

export default component.exports